<div class="content-container">
  @for (content of contents(); track content) {
    <span class="content-text" (click)="textClicked(content)">{{ content.text }}</span
    >{{ ' ' }}
  }
</div>
